import { FormBuilder, Validators } from '@angular/forms';
import { Examen } from '../Examen.config';
import { apellidoNombreTrabajadorValidator } from '../../../../../utils/apellido-nombre-trabajador-validator';

export class EstudioSUV extends Examen {
  id = 10;
  code = 'ORL';
  name = 'ESTUDIO SOBRECARGA DE USO DE VOZ';
  baseUrl = 'estudios/carga';
  isAttachedFileRequire = false;
  sections = [
    {
      name: 'ESTUDIO PARA S.U.V',
      fields: {
        fechaRealizacion: ['', [ Validators.required ]],
      },
    },
    {
      name: 'Empleador',
      fields: {},
      numberForm: 1,
    },
    {
      name: 'Trabajador',
      fields: {
        apellidoNombre:['', [Validators.required, Validators.maxLength(100), apellidoNombreTrabajadorValidator]],
        fechaNacimiento: ['', [Validators.required]],    
        puestoTrabajador: ['', [Validators.required]],
        fechaIngresoEmpresa: ['', [Validators.required]],
        antiguedadPuestoTrabajador: ['', [Validators.required]],
        antiguedadOtrosCargos: [ false, [Validators.required]],
        antiguedadDescripcion: [ {value: '', disabled: true} ],
      },
      numberForm: 2,
    },
    {
      name: 'Actividad/Puesto',
      fields: {
        docente: [ false, [Validators.required] ],
        titular: [ {value: false, disabled: true} ],
        provisorio: [ {value: false, disabled: true} ],
        suplente: [ {value: false, disabled: true} ],
        cargaHorariaDiaria: [{value: '', disabled: true}],
        cargaHorariaSemanal: [{value: '', disabled: true}],
        educacionPrePrimario: [ {value: false, disabled: true} ],
        educacionEnPrimario: [ {value: false, disabled: true} ],
        educacionEnSecundario: [ {value: false, disabled: true} ],
        educacionEnTerciario: [ {value: false, disabled: true} ],
        educacionEnUniversitario: [ {value: false, disabled: true} ],
        cargaHorariaOtroEstablecimiento: [ false, [Validators.required] ],
        otroEstablecimientoTitular: [ {value: false, disabled: true} ],
        otroEstablecimientoProvisorio: [ {value: false, disabled: true} ],
        otroEstablecimientoSuplente: [ {value: false, disabled: true} ],
        otroEstabCargaHorariaDiaria: [{value: '', disabled: true}],
        otroEstabCargaHorariaSemanal: [{value: '', disabled: true}],
        otroEstabEducacionPrePrimario: [ {value: false, disabled: true} ],
        otroEstabEducacionEnPrimario: [ {value: false, disabled: true} ],
        otroEstabEducacionEnSecundario: [ {value: false, disabled: true} ],
        otroEstabEducacionEnTerciario: [ {value: false, disabled: true} ],
        otroEstabEducacionEnUniversitario: [ {value: false, disabled: true} ],
        callCenter: [ false, [Validators.required] ],
        callCenterCargaHorariaDiaria: [{value: '', disabled: true}],
        callCenterCargaHorariaSemanal: [{value: '', disabled: true}],
        callCenterDescripcion: [{value: '', disabled: true}],
        otro: [ false, [Validators.required] ],
        otroCargaHorariaDiaria: [{value: '', disabled: true}],
        otroCargaHorariaSemanal: [{value: '', disabled: true}],
        otroDescripcion: [{value: '', disabled: true}],
      },
      numberForm: 3,
    },
    {
      name: 'TrabajadoresServiciosTelefonicos',
      fields: {
        monoaural: [ false ],
        biaural: [ true ],
        reguladorVolumen: [ true ],
        servicioTelefonicoDescripcion: ['', Validators.maxLength(250)],
      },
      numberForm: 4,
    },
    {
      name: 'Habitos',
      fields: {
        tomaAlcohol:  [ false, [Validators.required] ],
        fuma:  [ false, [Validators.required] ],
        fumaCantidad: [ {value: '', disabled: true} ],
        fumaDesde: [ {value: null, disabled: true} ],
        tomaMedicacion:  [ false, [Validators.required] ],
        tomaMedicacionDetalle: [ {value: '', disabled: true} ],
        realizaOtrasActividadesEsfuerzovoz:  [ false, [Validators.required] ],
        habitosDescripcion: [ {value: '', disabled: true} ],
      },
      numberForm: 5,
    },
    {
      name: 'Antecedentes',
      fields: {
        respiratorios: [ false, [Validators.required] ],
        respiratoriosDesc:  [ {value: '', disabled: true} ],
        alergicos: [ false, [Validators.required] ],
        alergicosDesc: [ {value: '', disabled: true} ],
        quirurgicos: [ false, [Validators.required] ],
        quirurgicosDesc: [ {value: '', disabled: true} ],
        digestivos: [ false, [Validators.required] ],
        digestivosDesc: [ {value: '', disabled: true} ],
        herniaHiatal: [ false, [Validators.required] ],
        herniaHiatalDesc: [ {value: '', disabled: true} ],
        reflujoGastroesofagico: [ false, [Validators.required] ],
        reflujoGastroesofagicoDesc: [ {value: '', disabled: true} ],
        tiroideos: [ false, [Validators.required] ],
        tiroideosDesc: [ {value: '', disabled: true} ],
        laringitisCronica: [ false, [Validators.required] ],
        laringitisCronicaDesde: [ {value: '', disabled: true} ],
        poliposFaringeos: [ false, [Validators.required] ],
        poliposLaringeosDesc: [ {value: '', disabled: true} ],
        nodulosVocales: [ false, [Validators.required] ],
        nodulosVocalesDesc: [ {value: '', disabled: true} ],
        disfonia: [ false, [Validators.required] ],
        disfoniaDesc: [ {value: '', disabled: true} ],
        disfoniaDesde: [ {value: '', disabled: true} ],
        antecedentesOtras: [ '', [Validators.required] ],
        caractSubjetivasVoz: [ '', [Validators.required] ]
      },
      numberForm: 6,
    },
    {
      name: 'Laringoscopia Indirecta',
      fields: {
        aspectoAnatomicoLaringe: [ {value: '', disabled: true} ],
        observaciones:  [ {value: '', disabled: true} ],
        diagnosticoSugerencias: [ {value: '', disabled: true} ],
      },
      numberForm: 7,
    },
    {
      name: 'Dictamen medico',
      fields: {
        medicoNombre: [ null, [ Validators.required, Validators.pattern( /^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]+$/ ) ]],
        codigoDictamen: [ null, [ Validators.required ]],
        medicoMatricula: [ null, [ Validators.required ]],
        medicoEspecialidad: [ null, [ Validators.required ]],
      },
      numberForm: 8,
    },
    {
      name: 'Adjuntos',
      fields: {},
      numberForm: 9,
    },
  ];

  constructor( formBuilder: FormBuilder ) {
    super( formBuilder );
    this.fieldList = this.getFields();
    this.examForm = this.getForm();
    this.sectionsList = this.getSections();
  }
}
